import Vue from "vue";
import application from "./application.vue";
import vuetify from "./plugins/vuetify";
import router from "@/router";
import store from "@/store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(application)
}).$mount("#application");
